const en_sliderLeftArrow = require("url:../../../assets/icons/left-arrow.svg");
const en_sliderRightArrow = require("url:../../../assets/icons/right-arrow.svg");

const en_indaloMediaLogo = require("url:../../../assets/indalo-media.svg");
const en_oilLogo = require("url:../../../assets/oil-combustibles.svg");
const en_cpcLogo = require("url:../../../assets/cpc-logo.svg");
const en_providenciaLogo = require("url:../../../assets/providencia-logo.svg");
const en_alpatLogo = require("url:../../../assets/alpat-logo.svg");
const en_sermaLogo = require("url:../../../assets/serma-logo.svg");
const en_pilgrimEnergyLogo = require("url:../../../assets/pilgrim-energy.svg");

class en_CompaniesSliderComponent extends HTMLElement {
	shadow = this.attachShadow({ mode: "open" });
	constructor() {
		super();

		const style = document.createElement("style");

		style.textContent = `
        
        .carousel-container {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            gap: 45px;
        }

        .carousel {
            width: 100%;
            margin: 0 auto;
            overflow: hidden;
        }

        @media (min-width: 630px) {
            .carousel {
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                overflow: hidden;
            }
        }

        .sliders-container {
            width: calc(100% + 13% * 5);
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 6%;
            transform: translateX(-40%);
            transition: all .7s ease;
			scroll-snap-type: x mandatory;
			scroll-behavior: smooth;
        }

        @media (min-width: 425px) {
            .sliders-container {
                gap: 10%;
            }
        }

		@media (min-width: 500px) {
			.sliders-container {
				transform: translateX(-37%);
			}
		}

        @media (min-width: 630px) {
            .sliders-container {
                transform: translateX(-15%);
            }
        }

        .slider__item {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            opacity: .35;
            transform: scale(0.9);
            transition: all .6s;
        }

        .slider__item.active {
            opacity: 1;
            transform: scale(1);            
        }

        .item__controlls {
            width: 100%;
            display: flex;
            justify-content: center;
            gap: 45px;
            mix-blend-mode: difference;
        }

        .left-arrow, 
        .right-arrow {
            opacity: 0.7;
        }

        .left-arrow:hover, 
        .right-arrow:hover {
            cursor: pointer;
            opacity: 1;
        }

        `;

		this.render();

		this.shadow.appendChild(style);
	}

	addListeners() {
		const carouselEl: HTMLElement = this.shadow.querySelector(".carousel");

		const SlContainerEl: HTMLElement =
			this.shadow.querySelector(".sliders-container");

		const slidersItemsEl = this.shadow.querySelectorAll(".slider__item");
		const leftArrowEl: HTMLElement =
			this.shadow.querySelector(".left-arrow");
		const rightArrowEl: HTMLElement =
			this.shadow.querySelector(".right-arrow");

		let isDragging = false,
			startPos = 0,
			currentTranslate = 0,
			prevTranslate = 0,
			animationID,
			currentIndex = 0;

		slidersItemsEl.forEach((slide, index) => {
			slide.addEventListener("touchstart", touchStart(index));
			slide.addEventListener("mousedown", touchStart(index));

			slide.addEventListener("touchend", touchEnd);
			slide.addEventListener("mouseup", touchEnd);

			slide.addEventListener("touchmove", touchMove);
			slide.addEventListener("mousemove", touchMove);
		});

		function getPositionX(event) {
			return event.type.includes("mouse")
				? event.pageX
				: event.touches[0].clientX;
		}

		function touchStart(index) {
			return function (event) {
				currentIndex = index;
				startPos = getPositionX(event);
				isDragging = true;
				animationID = requestAnimationFrame(animation);
			};
		}

		function touchMove(event) {
			if (isDragging) {
				const currentPosition = getPositionX(event);
				currentTranslate = prevTranslate + currentPosition - startPos;
			}
		}

		function touchEnd() {
			cancelAnimationFrame(animationID);
			isDragging = false;

			const offset = SlContainerEl.getAttribute("offset");
			const movedBy = currentTranslate - prevTranslate;

			// if moved enough negative then snap to next slide if there is one
			if (window.innerWidth <= 425) {
				if (movedBy > 100 && offset == "0") {
					SlContainerEl.style.transform = "translateX(-120%)";
					SlContainerEl.setAttribute("offset", "5");
				} else if (movedBy > 100 && offset == "1") {
					SlContainerEl.style.transform = "translateX(80%)";
					SlContainerEl.setAttribute("offset", "0");
				} else if (movedBy > 100 && offset == "2") {
					SlContainerEl.style.transform = "translateX(40%)";
					SlContainerEl.setAttribute("offset", "1");
				} else if (movedBy > 100 && offset == "3") {
					SlContainerEl.style.transform = "translateX(0%)";
					SlContainerEl.setAttribute("offset", "2");
				} else if (movedBy > 100 && offset == "4") {
					SlContainerEl.style.transform = "translateX(-40%)";
					SlContainerEl.setAttribute("offset", "3");
				} else if (movedBy > 100 && offset == "5") {
					SlContainerEl.style.transform = "translateX(-80%)";
					SlContainerEl.setAttribute("offset", "4");
				}
			} else if (window.innerWidth >= 450 && window.innerWidth < 600) {
				if (movedBy > 100 && offset == "0") {
					SlContainerEl.style.transform = "translateX(-108%)";
					SlContainerEl.setAttribute("offset", "5");
				} else if (movedBy > 100 && offset == "1") {
					SlContainerEl.style.transform = "translateX(69%)";
					SlContainerEl.setAttribute("offset", "0");
				} else if (movedBy > 100 && offset == "2") {
					SlContainerEl.style.transform = "translateX(34%)";
					SlContainerEl.setAttribute("offset", "1");
				} else if (movedBy > 100 && offset == "3") {
					SlContainerEl.style.transform = "translateX(-2%)";
					SlContainerEl.setAttribute("offset", "2");
				} else if (movedBy > 100 && offset == "4") {
					SlContainerEl.style.transform = "translateX(-37%)";
					SlContainerEl.setAttribute("offset", "3");
				} else if (movedBy > 100 && offset == "5") {
					SlContainerEl.style.transform = "translateX(-73%)";
					SlContainerEl.setAttribute("offset", "4");
				}
			} else if (window.innerWidth >= 630) {
				if (movedBy > 100 && offset == "0") {
					SlContainerEl.style.transform = "translateX(-75%)";
					SlContainerEl.setAttribute("offset", "5");
				} else if (movedBy > 100 && offset == "1") {
					SlContainerEl.style.transform = "translateX(75%)";
					SlContainerEl.setAttribute("offset", "0");
				} else if (movedBy > 100 && offset == "2") {
					SlContainerEl.style.transform = "translateX(45%)";
					SlContainerEl.setAttribute("offset", "1");
				} else if (movedBy > 100 && offset == "3") {
					SlContainerEl.style.transform = "translateX(15%)";
					SlContainerEl.setAttribute("offset", "2");
				} else if (movedBy > 100 && offset == "4") {
					SlContainerEl.style.transform = "translateX(-15%)";
					SlContainerEl.setAttribute("offset", "3");
				} else if (movedBy > 100 && offset == "5") {
					SlContainerEl.style.transform = "translateX(-45%)";
					SlContainerEl.setAttribute("offset", "4");
				}
			}

			if (window.innerWidth <= 425) {
				if (movedBy < -100 && offset == "0") {
					SlContainerEl.style.transform = "translateX(40%)";
					SlContainerEl.setAttribute("offset", "1");
				} else if (movedBy < -100 && offset == "1") {
					SlContainerEl.style.transform = "translateX(0%)";
					SlContainerEl.setAttribute("offset", "2");
				} else if (movedBy < -100 && offset == "2") {
					SlContainerEl.style.transform = "translateX(-40%)";
					SlContainerEl.setAttribute("offset", "3");
				} else if (movedBy < -100 && offset == "3") {
					SlContainerEl.style.transform = "translateX(-80%)";
					SlContainerEl.setAttribute("offset", "4");
				} else if (movedBy < -100 && offset == "4") {
					SlContainerEl.style.transform = "translateX(-120%)";
					SlContainerEl.setAttribute("offset", "5");
				} else if (movedBy < -100 && offset == "5") {
					SlContainerEl.style.transform = "translateX(80%)";
					SlContainerEl.setAttribute("offset", "0");
				}
			} else if (window.innerWidth >= 450 && window.innerWidth < 600) {
				if (movedBy < -100 && offset == "0") {
					SlContainerEl.style.transform = "translateX(34%)";
					SlContainerEl.setAttribute("offset", "1");
				} else if (movedBy < -100 && offset == "1") {
					SlContainerEl.style.transform = "translateX(-2%)";
					SlContainerEl.setAttribute("offset", "2");
				} else if (movedBy < -100 && offset == "2") {
					SlContainerEl.style.transform = "translateX(-37%)";
					SlContainerEl.setAttribute("offset", "3");
				} else if (movedBy < -100 && offset == "3") {
					SlContainerEl.style.transform = "translateX(-73%)";
					SlContainerEl.setAttribute("offset", "4");
				} else if (movedBy < -100 && offset == "4") {
					SlContainerEl.style.transform = "translateX(-108%)";
					SlContainerEl.setAttribute("offset", "5");
				} else if (movedBy < -100 && offset == "5") {
					SlContainerEl.style.transform = "translateX(69%)";
					SlContainerEl.setAttribute("offset", "0");
				}
			} else if (window.innerWidth >= 630) {
				if (movedBy < -100 && offset == "0") {
					SlContainerEl.style.transform = "translateX(45%)";
					SlContainerEl.setAttribute("offset", "1");
				} else if (movedBy < -100 && offset == "1") {
					SlContainerEl.style.transform = "translateX(15%)";
					SlContainerEl.setAttribute("offset", "2");
				} else if (movedBy < -100 && offset == "2") {
					SlContainerEl.style.transform = "translateX(-15%)";
					SlContainerEl.setAttribute("offset", "3");
				} else if (movedBy < -100 && offset == "3") {
					SlContainerEl.style.transform = "translateX(-45%)";
					SlContainerEl.setAttribute("offset", "4");
				} else if (movedBy < -100 && offset == "4") {
					SlContainerEl.style.transform = "translateX(-75%)";
					SlContainerEl.setAttribute("offset", "5");
				} else if (movedBy < -100 && offset == "5") {
					SlContainerEl.style.transform = "translateX(75%)";
					SlContainerEl.setAttribute("offset", "0");
				}
			}
		}

		function animation() {
			if (isDragging) requestAnimationFrame(animation);
		}

		const leftArrowListener = (e) => {
			const target = e.target as HTMLElement;
			const position = target.getAttribute("position");
			const offset = SlContainerEl.getAttribute("offset");

			if (window.innerWidth <= 425) {
				if (position == "previous" && offset == "0") {
					SlContainerEl.style.transform = "translateX(-120%)";
					SlContainerEl.setAttribute("offset", "5");
				} else if (position == "previous" && offset == "1") {
					SlContainerEl.style.transform = "translateX(80%)";
					SlContainerEl.setAttribute("offset", "0");
				} else if (position == "previous" && offset == "2") {
					SlContainerEl.style.transform = "translateX(40%)";
					SlContainerEl.setAttribute("offset", "1");
				} else if (position == "previous" && offset == "3") {
					SlContainerEl.style.transform = "translateX(0%)";
					SlContainerEl.setAttribute("offset", "2");
				} else if (position == "previous" && offset == "4") {
					SlContainerEl.style.transform = "translateX(-40%)";
					SlContainerEl.setAttribute("offset", "3");
				} else if (position == "previous" && offset == "5") {
					SlContainerEl.style.transform = "translateX(-80%)";
					SlContainerEl.setAttribute("offset", "4");
				}
			} else if (window.innerWidth >= 450 && window.innerWidth < 600) {
				if (position == "previous" && offset == "0") {
					SlContainerEl.style.transform = "translateX(-108%)";
					SlContainerEl.setAttribute("offset", "5");
				} else if (position == "previous" && offset == "1") {
					SlContainerEl.style.transform = "translateX(69%)";
					SlContainerEl.setAttribute("offset", "0");
				} else if (position == "previous" && offset == "2") {
					SlContainerEl.style.transform = "translateX(34%)";
					SlContainerEl.setAttribute("offset", "1");
				} else if (position == "previous" && offset == "3") {
					SlContainerEl.style.transform = "translateX(-2%)";
					SlContainerEl.setAttribute("offset", "2");
				} else if (position == "previous" && offset == "4") {
					SlContainerEl.style.transform = "translateX(-37%)";
					SlContainerEl.setAttribute("offset", "3");
				} else if (position == "previous" && offset == "5") {
					SlContainerEl.style.transform = "translateX(-73%)";
					SlContainerEl.setAttribute("offset", "4");
				}
			} else if (window.innerWidth >= 630) {
				if (position == "previous" && offset == "0") {
					SlContainerEl.style.transform = "translateX(-75%)";
					SlContainerEl.setAttribute("offset", "5");
				} else if (position == "previous" && offset == "1") {
					SlContainerEl.style.transform = "translateX(75%)";
					SlContainerEl.setAttribute("offset", "0");
				} else if (position == "previous" && offset == "2") {
					SlContainerEl.style.transform = "translateX(45%)";
					SlContainerEl.setAttribute("offset", "1");
				} else if (position == "previous" && offset == "3") {
					SlContainerEl.style.transform = "translateX(15%)";
					SlContainerEl.setAttribute("offset", "2");
				} else if (position == "previous" && offset == "4") {
					SlContainerEl.style.transform = "translateX(-15%)";
					SlContainerEl.setAttribute("offset", "3");
				} else if (position == "previous" && offset == "5") {
					SlContainerEl.style.transform = "translateX(-45%)";
					SlContainerEl.setAttribute("offset", "4");
				}
			}
		};

		const rightArrowListener = (e) => {
			const target = e.target as HTMLElement;
			const position = target.getAttribute("position");
			const offset = SlContainerEl.getAttribute("offset");

			if (window.innerWidth <= 425) {
				if (position == "next" && offset == "0") {
					SlContainerEl.style.transform = "translateX(40%)";
					SlContainerEl.setAttribute("offset", "1");
				} else if (position == "next" && offset == "1") {
					SlContainerEl.style.transform = "translateX(0%)";
					SlContainerEl.setAttribute("offset", "2");
				} else if (position == "next" && offset == "2") {
					SlContainerEl.style.transform = "translateX(-40%)";
					SlContainerEl.setAttribute("offset", "3");
				} else if (position == "next" && offset == "3") {
					SlContainerEl.style.transform = "translateX(-80%)";
					SlContainerEl.setAttribute("offset", "4");
				} else if (position == "next" && offset == "4") {
					SlContainerEl.style.transform = "translateX(-120%)";
					SlContainerEl.setAttribute("offset", "5");
				} else if (position == "next" && offset == "5") {
					SlContainerEl.style.transform = "translateX(80%)";
					SlContainerEl.setAttribute("offset", "0");
				}
			} else if (window.innerWidth >= 450 && window.innerWidth < 600) {
				if (position == "next" && offset == "0") {
					SlContainerEl.style.transform = "translateX(34%)";
					SlContainerEl.setAttribute("offset", "1");
				} else if (position == "next" && offset == "1") {
					SlContainerEl.style.transform = "translateX(-2%)";
					SlContainerEl.setAttribute("offset", "2");
				} else if (position == "next" && offset == "2") {
					SlContainerEl.style.transform = "translateX(-37%)";
					SlContainerEl.setAttribute("offset", "3");
				} else if (position == "next" && offset == "3") {
					SlContainerEl.style.transform = "translateX(-73%)";
					SlContainerEl.setAttribute("offset", "4");
				} else if (position == "next" && offset == "4") {
					SlContainerEl.style.transform = "translateX(-108%)";
					SlContainerEl.setAttribute("offset", "5");
				} else if (position == "next" && offset == "5") {
					SlContainerEl.style.transform = "translateX(69%)";
					SlContainerEl.setAttribute("offset", "0");
				}
			} else if (window.innerWidth >= 630) {
				if (position == "next" && offset == "0") {
					SlContainerEl.style.transform = "translateX(45%)";
					SlContainerEl.setAttribute("offset", "1");
				} else if (position == "next" && offset == "1") {
					SlContainerEl.style.transform = "translateX(15%)";
					SlContainerEl.setAttribute("offset", "2");
				} else if (position == "next" && offset == "2") {
					SlContainerEl.style.transform = "translateX(-15%)";
					SlContainerEl.setAttribute("offset", "3");
				} else if (position == "next" && offset == "3") {
					SlContainerEl.style.transform = "translateX(-45%)";
					SlContainerEl.setAttribute("offset", "4");
				} else if (position == "next" && offset == "4") {
					SlContainerEl.style.transform = "translateX(-75%)";
					SlContainerEl.setAttribute("offset", "5");
				} else if (position == "next" && offset == "5") {
					SlContainerEl.style.transform = "translateX(75%)";
					SlContainerEl.setAttribute("offset", "0");
				}
			}
		};

		leftArrowEl.addEventListener("click", leftArrowListener);
		rightArrowEl.addEventListener("click", rightArrowListener);

		var observer = new MutationObserver(function (mutations) {
			mutations.forEach(function (mutation) {
				if (mutation.type === "attributes") {
					slidersItemsEl.forEach((item) => {
						const itemOffset = item.getAttribute("offset");
						const sliderOffset =
							SlContainerEl.getAttribute("offset");
						if (sliderOffset == itemOffset) {
							item.classList.add("active");
						} else {
							item.classList.remove("active");
						}
					});
				}
			});
		});

		observer.observe(SlContainerEl, {
			attributes: true,
		});

		const translationOnResize = () => {
			leftArrowEl.removeEventListener("click", leftArrowListener);
			leftArrowEl.removeEventListener("click", rightArrowListener);

			leftArrowEl.addEventListener("click", leftArrowListener);
			rightArrowEl.addEventListener("click", rightArrowListener);
		};

		window.addEventListener("resize", translationOnResize);
	}

	render() {
		this.shadow.innerHTML = `
        <div class="carousel-container">
            <div class="carousel">
                <div class="sliders-container" offset="3">
                    <div class="slider__item" offset="0">
                        <en-company-card path="/en/company/indalo-media" src="${en_indaloMediaLogo}">
						One of the principal multimedia companies in Argentina. It has a strong presence in the television, radio, graphic and digital media industries and in the production of audiovisual content.
                        </en-company-card>
                    </div>
                    <div class="slider__item" offset="1">
                        <en-company-card path="/en/company/oil-m&s" src="${en_oilLogo}">
						Company providing comprehensive solutions to the hydrocarbon and mining industries throughout the country.
                        </en-company-card>
                    </div>
                    <div class="slider__item" offset="2">
                        <en-company-card path="/en/company/cpc" src="${en_cpcLogo}">
						Leading company in the implementation of large-scale public work projects.
                        </en-company-card>
                    </div> 
                    <div class="slider__item active" offset="3">
                        <en-company-card path="/en/company/providencia" src="${en_providenciaLogo}">
						Insurance company specialized in providing a wide range of services to individuals and companies through brokers and producers.
                        </en-company-card>
                    </div>
                    <div class="slider__item" offset="4">
                        <en-company-card path="/en/company/alpat" src="${en_alpatLogo}">
						The only sodium carbonate producer in Latin America.
                        </en-company-card>
                    </div>
                    <div class="slider__item" offset="5">
                        <en-company-card path="/en/company/serma" src="${en_sermaLogo}">
						Providing environmental engineering services to companies in the hydrocarbon and mining industries. 
                        </en-company-card>
                    </div>
                </div>
            </div>
            <div class="item__controlls">
            <img class="chevron-arrow left-arrow" src="${en_sliderLeftArrow}" position="previous">
            <img class="chevron-arrow right-arrow" src="${en_sliderRightArrow}" position="next">
            </div>
        </div>
        `;
		this.addListeners();
	}
}
customElements.define("en-companies-slider", en_CompaniesSliderComponent);
